import axios from 'axios';

document.addEventListener('DOMContentLoaded', () => {
	const displayContestFormButton = document.getElementById('contest-work-add');
	const contestForm = document.getElementById('contest-work-form');

	if (!displayContestFormButton || !contestForm) return;

	displayContestFormButton.addEventListener('click', (event) => {
		contestForm.classList.toggle('visually-hidden');
	});


	contestForm.addEventListener('submit', (event) => {
		event.preventDefault();

		let { body } = document;

		const { action: url } = event.currentTarget;
		let data = new FormData(contestForm);
		contestForm.reset();

		axios.post(url, data, {
			responseType: 'json',
		}).then(function (response) {
			if (response.data.status) {
				return response;
			} else {
				let err = 'False status response';
				console.error(err);
				throw new Error(err);
			}
		}).then(function (response) {
			let button = contestForm.querySelector('button');
			let div = document.createElement('div');
			div.classList.add('text-white', 'bg-green', 'px-4', 'py-2', 'mt-4');
			div.append('Форма отправлена! Данные отобразяться после прохождения модерации.');

			contestForm.replaceChild(div, button);
		}).catch(function (error) {
			console.error(error.message);
			throw new Error(error.message);
		});
	})
}, { once: true });
